import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import { DraftBanner } from "@/pages/Privacy";

export default function Terms() {
  return (
    <>
      <Seo
        title="Terms of Service (Draft) — Riverstone Partners"
        description="Draft terms of service for Riverstone Partners, prepared for business review prior to launch."
        path="/terms"
      />
      <DraftBanner />
      <section className="py-16 md:py-24">
        <div className="shell max-w-3xl space-y-10">
          <div>
            <p className="eyebrow text-forest">Legal</p>
            <h1 className="mt-4 font-serif text-4xl font-light tracking-tight text-navy" data-testid="terms-title">
              Terms of Service
            </h1>
            <p className="mt-2 text-sm text-charcoal/60">Draft — [Effective date to be set at launch]</p>
          </div>

          {[
            ["Purpose of this website", (
              <>
                This website introduces Riverstone Partners and the solution areas we
                help explore. It is informational; nothing here is a contract, an offer,
                professional advice, or a guarantee of results.
              </>
            )],
            ["No professional or investment advice", (
              <>
                Content on this site, including pages describing Emerging Opportunities,
                is general information, not legal, tax, medical, or investment advice.
                Decisions made after conversations with us or our providers are your own.
              </>
            )],
            ["Role of providers", (
              <>
                Services are delivered by independent specialist providers. Each
                provider’s own terms govern its work. Riverstone Partners facilitates
                introductions and coordination but is not the provider of those services.
              </>
            )],
            ["Affiliate opportunity", (
              <>
                The Aspire Partners opportunity described here is an independent referral
                program, not employment, and participation terms are set by Aspire
                Partners. No earnings are guaranteed.
              </>
            )],
            ["Inquiries and communications", (
              <>
                When you submit a form, you consent to being contacted about your
                inquiry. You may ask us to stop at any time.
              </>
            )],
            ["Intellectual property", (
              <>
                The Riverstone Partners name, logo, and site content belong to Riverstone
                Partners. Third-party names and marks belong to their respective owners.
              </>
            )],
            ["Changes", (
              <>
                These terms are a draft for business review and may change materially
                before launch. The final version will carry an effective date.
              </>
            )],
          ].map(([h, body], i) => (
            <Reveal key={h} delay={i * 0.03}>
              <h2 className="font-serif text-2xl text-navy">{h}</h2>
              <p className="mt-3 leading-relaxed text-charcoal/80">{body}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
